"use client";

import { useTranslations } from "next-intl";
import { ErrorView } from "@/components/error-view";

export default function NotFound() {
  const t = useTranslations();
  return (
    <ErrorView
      code="404"
      title={t("errors.404.title")}
      description={t("errors.404.description")}
    />
  );
}
